import $ from 'jquery';
import 'bootstrap';

import { clearTabLeaveWarning, addTabLeaveWarning } from "stdjs/standard-tab-page";
import { debounceFunc, clearPageLeaveWarning, addPageLeaveWarning } from "stdjs/utilities";
import { clearModalLeaveWarning, addModalLeaveWarning } from 'stdjs/modals';
import Translator from 'stdjs/translate-service';

// todo change so tab container passes in as id instead
export function clearPageLeaveWarnings( pageIdentifier, $tabContainer, modalId ){
    clearPageLeaveWarning( pageIdentifier );
    clearTabLeaveWarning( pageIdentifier, $tabContainer );  
    clearModalLeaveWarning( pageIdentifier, modalId ); 
}

export function addPageLeaveWarnings( pageIdentifier, $tabContainer, modalId ){
    var successCallback = function(){
        clearPageLeaveWarnings( pageIdentifier, $tabContainer, modalId );
    }
    addPageLeaveWarning( pageIdentifier, Translator.tr( "You have unsaved changes. Are you sure you wish to leave?" ) );
    addTabLeaveWarning( pageIdentifier, $tabContainer,  successCallback);
    addModalLeaveWarning( pageIdentifier, modalId, successCallback );   
}